module.exports = __webpack_public_path__ + "img/record.2a22d63b.svg";